import React, { useState, useEffect } from "react";
import Select from "../../../components/select/selectField";
import { Table, TableColumn } from "../../../components/table";
import MainButton from "../../../components/button/mainButton";
import TextBox from "../../../components/textfield/textbox";
import HeaderBar from "../../../components/header/headerBar";
import { useHistory } from "react-router-dom";
import { Input } from "../../../components/textfield";
import Icon from "@mdi/react";
import { mdiPrinter } from "@mdi/js";
import "../../../assets/styles/admin/usedcourse.scss";

const Courserenew = () => {
  const [visible, _visible] = useState(false);
  const history = useHistory();
  const headData = {
    customer: "น.ส ธันยรัศมิ์ จิระรุ่งโรจน์",
    cn: "R9-CNT61080007",
    so: "SO-63010147",
    date: "2564-01-18",
    expiredate: "26-01-2564",
  };
  const columns = [
    {
      title: "No",
    },
    {
      title: "รายการ",
    },
    {
      title: "ทั้งหมด",
      align: "center",
    },
    {
      title: "ใช้ไปแล้ว",
      align: "center",
    },
    {
      title: "คงเหลือ",
      align: "center",
    },
    {
      title: "หมดอายุ",
      align: "center",
    },
  ];

  const data2 = [
    {
      _id: 1,
      list: "Dual Yellow 5 Times",
      total: "5,000.00",
      used: "1,000.00",
      remaining: "4,000.00",
      empire_date: "26-01-2564",
      renew_date: "26-07-2564",
      statuscourse: "Renewal",
    },
  ];
  const months = [
    //{ value: '', name: '3 เดือน' },
    { value: "", name: "6 เดือน" },
    // { value: '', name: '12 เดือน' }
  ];

  return (
    <div>
      <HeaderBar title="ต่ออายุคอร์ส" btnBack />
      {/* <ConFirmModal type={1} show={showModal1} onClose={toggleModal1} /> */}
      <div style={{ padding: "20px 40px" }}>
        <div className="card-view" style={{ padding: "30px 10px" }}>
          <div className="row" style={{ padding: "20px 40px" }}>
            <TextBox
              className="col-3 text-box-usedc"
              title="Customer"
              value="น.ส ธันยรัศมิ์ จิระรุ่งโรจน์"
            />
            <TextBox
              className="col-3 text-box-usedc"
              title="CN"
              value="R9-CNT61080007"
            />
            <TextBox
              className="col-3 text-box-usedc"
              title="SO"
              value="SO-63010147"
            />
            <Input
              className="col-3 input-usedc"
              title="DATE"
              type="date"
              value={""}
            />
          </div>

          <div className="row" style={{ padding: "20px 40px" }}>
            <TextBox
              className="col-3 text-box-usedc"
              title="EXPIRE DATE"
              value="26-01-2564"
            />
            <Select
              className="col-3 select-field-usedc "
              title="Renewal"
              placeholder="เดือน"
              option={months}
            />
          </div>

          <div style={{ marginTop: "20px" }}>
            <Table header={columns}>
              {data2.map((item, index) => (
                <tr
                  key={index}
                  // onClick={() => history.push(`/usedcourse/${item.SO}`)}
                  style={{ cursor: "pointer" }}
                >
                  <TableColumn width="3%" align="center">
                    {index + 1}
                  </TableColumn>
                  <TableColumn width="30%">{item.list}</TableColumn>
                  <TableColumn width="5%">{item.total}</TableColumn>
                  <TableColumn width="5%" align="left">
                    {item.used}
                  </TableColumn>
                  <TableColumn width="5%" align="left">
                    {item.remaining}
                  </TableColumn>
                  <TableColumn width="10%" align="right" key={index}>
                    {item.empire_date}
                  </TableColumn>
                </tr>
              ))}
            </Table>
            <div style={{ marginTop: "20px" }}>
              <Input className="col-12" title="Remark" type="Text" />
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          <MainButton
            title="พิมพ์ใบขอรับบริการ"
            background="#4285F4"
            className="mg-10"
          >
            <Icon path={mdiPrinter} size="20" color="#fff" />
          </MainButton>
          <MainButton
            title="พิมพ์ขอต่ออายุคอร์ส"
            background="#4285F4"
            className="mg-10"
          >
            <Icon path={mdiPrinter} size="20" color="#fff" />
          </MainButton>
          <MainButton
            title="บันทึก"
            background="#4D7E7F"
            className="mg-10"
            onClick={() =>
              history.push(`/usedcourse/coursedetail/1/courserenew1`)
            }
          />
        </div>
      </div>
    </div>
  );
};
export default Courserenew;
